import { Grid } from "@mui/material";
import TitleHeading from "./title-heading";
import TitleDescription from "./title-description";

const Title2 = ({
    title,
    description,
    chipLabel="",
    chipIcon=null,
    chipColor
}) => {
    return (
        <>
            <Grid
                direction={{xs: 'column', md: 'row'}}
                justifyContent={{xs: 'start', md: 'space-between'}}
                alignItems={{xs: 'center', md: 'start'}}
                sx={{
                    width: '100%',
                    pb: {xs: 2, md: 5}
                }}
                spacing={{xs: 1, md: 1.5}}
                container
            >
                <Grid
                    size={{xs: 12, md: 6}}
                >
                    <TitleHeading 
                        title={title} 
                        textAlign="left"
                        chipLabel={chipLabel}
                        chipIcon={chipIcon}
                        chipColor={chipColor}
                        chipAlignment="start"
                    />
                </Grid>

                <Grid
                    size={{xs: 12, md: 6}}
                >
                    <TitleDescription description={description} textAlign="left"/>
                </Grid>
            </Grid>
        </>
    );
}

export default Title2;